export default __webpack_public_path__ + "static/media/Bracers of the Revelations of Tarim.b8c1cf86.jpg";